import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _get from "@babel/runtime-corejs2/helpers/get";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/createSuper";
/* global window: true */
// TODO enable flow
/* eslint-disable flowtype/require-valid-file-annotation */

import Fetcher from '@gandi/fetcher';
import createFetcherMiddleware from 'gandi.redux-fetcher';
var InstrumentedFetcher = /*#__PURE__*/function (_Fetcher) {
  _inherits(InstrumentedFetcher, _Fetcher);
  var _super = _createSuper(InstrumentedFetcher);
  // This class is not in src/server/intrumentation.js to avoid a dependency
  // on zipkin in the client bundle.
  // Intrumentation is injected from server whenever necessary.

  function InstrumentedFetcher(baseUrl) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var instrumentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, InstrumentedFetcher);
    _this = _super.call(this, baseUrl, options);
    if (instrumentation) {
      _this._instrumentation = instrumentation;
    }
    return _this;
  }
  _createClass(InstrumentedFetcher, [{
    key: "fetch",
    value: function fetch(url) {
      var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this._instrumentation) {
        return _get(_getPrototypeOf(InstrumentedFetcher.prototype), "fetch", this).call(this, url, fetchOptions);
      }
      var tracer = this._instrumentation.subrequest();
      var req = tracer.trace(url, fetchOptions);
      return _get(_getPrototypeOf(InstrumentedFetcher.prototype), "fetch", this).call(this, url, req.opts).then(req.success, req.error);
    }
  }]);
  return InstrumentedFetcher;
}(Fetcher);
/**
 * Return the fetcher options according to the target.
 */
var getOptions = function getOptions(target) {
  return function (args) {
    var options = {};
    var locale = args.locale,
      appUrl = args.appUrl;
    if (target === 'server') {
      var req = args.req;
      var headers = {
        origin: appUrl,
        'X-Real-IP': req.ip,
        'X-Forwarded-For': req.ip,
        'X-Forwarded-Proto': req.protocol,
        'X-Forwarded-Port': req.protocol === 'https' ? '443' : '80',
        'Accept-Language': locale
      };
      if (req.get('X-Country-Code')) {
        headers['X-Country-Code'] = req.get('X-Country-Code');
      }
      if (req.cookies.get('session')) {
        headers.Cookie = "session=".concat(req.cookies.get('session'));
      }
      options = _objectSpread(_objectSpread({}, options), {}, {
        headers: headers
      });
    }
    if (target === 'client') {
      var _headers = {
        'Accept-Language': locale
      };
      options = _objectSpread(_objectSpread({}, options), {}, {
        headers: _headers
      });
    }
    return options;
  };
};

/**
 * Initialize an instance of fetcher and return the middleware redux using
 * that instance.
 *
 * @param  {object} logger  Logger instance
 * @param  {string} target  "server" or "client"
 * @param  {object} config  ConfigBag instance of the app configuration
 * @return {Object}         Middleware
 */
export var initFetcherMiddleware = function initFetcherMiddleware(logger, __, target, apiEndpoint, locale, appUrl) {
  return function (fetcherOptionsArgs) {
    var fetcher = new Fetcher(apiEndpoint);
    if (target === 'server' && fetcherOptionsArgs.req && fetcherOptionsArgs.req.tracer) {
      var req = fetcherOptionsArgs.req;
      var instrumentation = req.tracer;
      fetcher = new InstrumentedFetcher(apiEndpoint, {}, instrumentation);
    }
    fetcher.setOptions(getOptions(target)(_objectSpread(_objectSpread({}, fetcherOptionsArgs), {}, {
      locale: locale,
      appUrl: appUrl
    })));
    var defaultHandlers = function defaultHandlers() {
      return {
        on401: function on401(res) {
          logger.info({
            res: res
          }, "401 Unauthorized : ".concat(res.data.message));

          // Pivoine catch 401 error so, in theory, we just need to handle
          // this error client side.
          if (typeof window !== 'undefined') {
            var lang = locale;
            window.location = "".concat(apiEndpoint, "/login?locale=").concat(lang, "&redirect=").concat(window.location);
          } else {
            logger.error('Uncaught unauthorized error');
          }
        }
      };
    };
    return createFetcherMiddleware(fetcher)(defaultHandlers);
  };
};